import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './reducers';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectLogoutSuccess = createSelector(selectAuthState, (authState: AuthState) => authState.logoutSuccess);

export const isLoggedIn = createSelector(selectAuthState, (auth) => !!auth?.userToken?.token);
export const isLoggedIn2 = createSelector(selectAuthState, (auth) => !!auth?.userToken?.token);

export const isLoggedOut = createSelector(isLoggedIn, (loggedIn) => !loggedIn);

export const getToken = createSelector(selectAuthState, (auth) => auth?.userToken.token);

export const getUser = createSelector(selectAuthState, (auth) => auth.userToken?.user);
